export interface UsageChartPoint {
  date: string;
  value: number | null;
}

type MeterUsage = { overall?: number };

/** Whether a meter recorded anything in the period: the usage page charts only those. */
export const isMeterUsed = (meter: MeterUsage | undefined): boolean => Boolean(meter?.overall);

/** Whether the usage page has a chart to draw for either period (else it lists unused meters only). */
export const hasUsageCharts = (
  usage: Record<"month" | "year", { meters: Record<string, MeterUsage> }>,
): boolean =>
  Object.values(usage.month.meters).some(isMeterUsed) ||
  Object.values(usage.year.meters).some(isMeterUsed);

export const aggregateUsageSeries = (
  series: UsageChartPoint[],
  period: "month" | "year",
): UsageChartPoint[] => {
  if (period === "month") return series;

  const monthlyValues = new Map<string, Array<number | null>>();
  for (const point of series) {
    const month = point.date.slice(0, 7);
    monthlyValues.set(month, [...(monthlyValues.get(month) || []), point.value]);
  }

  return Array.from(monthlyValues, ([date, values]) => {
    const populatedValues = values.filter((value): value is number => value !== null);
    if (!populatedValues.length) return { date, value: null };

    return { date, value: populatedValues.reduce((sum, value) => sum + value, 0) };
  });
};
